import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

export const PlusIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={() => {
        return (
          <>
            <line
              x1="3.5"
              y1="0.527344"
              x2="3.5"
              y2="6.54922"
              stroke={props.color ?? "currentColor"}
              strokeLinecap="round"
            />
            <line
              x1="6.5"
              y1="3.53906"
              x2="0.5"
              y2="3.53906"
              stroke={props.color ?? "currentColor"}
              strokeLinecap="round"
            />
          </>
        );
      }}
      {...props}
      viewBox="0 0 7 7"
    >
      {props.children}
    </IconBase>
  );
});

PlusIcon.displayName = "Plus";
